//Global imports
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface previewImage {
    image: string;
    filePath: string;
    width: number;
    height: number;
    fileSizeInKb: number;
}

interface ImageState {
    previewImages: previewImage[];
}

const initialState: ImageState = {
    previewImages: [],
};

const templatePreviewImagesSlice = createSlice({
    name: 'templatePreviewImages',
    initialState,
    reducers: {
        addTemplatePreviewImage: (state, action: PayloadAction<previewImage>) => {
            state.previewImages.unshift(action.payload);
        },
        removeTemplatePreviewImage: (state, action: PayloadAction<string>) => {
            state.previewImages = state.previewImages.filter(
                (img) => img.image !== action.payload,
            );
        },
        setPositionTemplatePreviewImage: (
            state,
            action: PayloadAction<previewImage[]>,
        ) => {
            state.previewImages = action.payload;
        },
        clearTemplatePreviewImage: (state) => {
            state.previewImages = [];
        },
    },
});

export const {
    addTemplatePreviewImage,
    removeTemplatePreviewImage,
    clearTemplatePreviewImage,
    setPositionTemplatePreviewImage,
} = templatePreviewImagesSlice.actions;

export default templatePreviewImagesSlice.reducer;
